@if (issuesByComponents$ | async; as pages) {
  <div role="status" aria-live="polite" class="visuallyhidden">
    {{ 'v_table_has_been_loaded' | translate: ('view_by' | translate) + ' ' + ('component' | translate) }}
  </div>
  <div class="d-flex mb-3">
    <div class="d-flex align-items-center flex-grow-1 header-items">
      @if (showListOfComponentsLabel) {
        <span class="text-black margin-right-lg list-of-components-label">{{ 'components_list' | translate }}</span>
      }
      <a [routerLink]="['/', Api.settings, Api.match_components]" class="text-underline">
        {{ 'manage_components' | translate }}
      </a>
    </div>
    <div class="pagination-entries pt-3 justify-content-end">
      <app-responsive-pagination
        [page]="page$ | async"
        [pageSize]="pageSize$ | async"
        [collectionSize]="totalRows$ | async"
        [entryLimits]="pageSizes"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></app-responsive-pagination>
    </div>
  </div>
  <div class="mb-3">
    <app-ngb-table [config]="tableConfig" [data]="tableData$ | async" [sortingOrder]="" (onSort)="onSort($event)"></app-ngb-table>
  </div>
  <div class="pagination-entries mb-0 justify-content-end">
    <app-responsive-pagination
      idSuffix="Bottom"
      [page]="page$ | async"
      [pageSize]="pageSize$ | async"
      [collectionSize]="totalRows$ | async"
      [entryLimits]="pageSizes"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    ></app-responsive-pagination>
  </div>
}
